import React from 'react';
import PropTypes from 'prop-types';
import HeaderDirectory from './HeaderDirectory';
import RowStation from './RowStation';
import { StyledTableWrapper } from './style';

const StationTable = ({ stationDirectory, onClickDetail }) => (
  <StyledTableWrapper>
    <HeaderDirectory />
    {stationDirectory.map((item, i) => (
      <RowStation
        key={`row-d-${i + 1}`}
        dataRow={item}
        onClickDetail={data => onClickDetail(data)}
      />
    ))}
  </StyledTableWrapper>
);

StationTable.propTypes = {
  stationDirectory: PropTypes.arrayOf(
    PropTypes.shape({
      community: PropTypes.string,
      concession: PropTypes.string,
      frecuency: PropTypes.string,
      phone: PropTypes.string
    })
  )
};

export default StationTable;
